import _axios from '../../apiClient'

export function confirmarCorreo(payload) {
  return _axios.post(`/api/Usuario/ConfirmarCorreo`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}